import * as ACTIONS from '../constants';

export function getSettings(payload) {
    return {
        type: ACTIONS.SETTINGS_GET,
        payload
    }
}

export function updateSettings(payload) {
    return {
        type: ACTIONS.SETTINGS_UPDATE,
        payload
    }
}

export function saveSettings(payload) {
    return {
        type: ACTIONS.SETTINGS_SAVE,
        payload
    }
}

export function settingsSaveCompleted() {
    return {
        type: ACTIONS.SETTINGS_SAVE_COMPLETE
    }
}